//正式环境和测试环境的接口域名地址定义
/*
 * WEBSITE：登录后接口域名地址
 * AUTHSITE：授权登录的接口域名地址
 */
const site_map = new Map().set('master', {
	WEBSITE: "https://api.umi365.com",
}).set('develop', {
	//WEBSITE: "http://127.0.0.1:410",
	WEBSITE: "http://api-dev.umi365.com",
});

/*根据环境变量，获取接口配置*/
const getSite=(env)=>{
	let site=site_map.get(env);
	return site
}
export default getSite;



// WEBPACK FOOTER //
// ./src/config/api.modal.js